import React from 'react';
import { Brain } from 'lucide-react';

interface AIInfoBannerProps {
  childName: string;
}

export function AIInfoBanner({ childName }: AIInfoBannerProps) {
  return (
    <div className="bg-gradient-to-r from-purple-50 to-blue-50 rounded-xl p-4 border border-purple-200">
      <div className="flex items-center space-x-3">
        <Brain className="w-6 h-6 text-purple-600" />
        <div>
          <h3 className="font-semibold text-purple-800">Real AI-Powered Generation</h3>
          <p className="text-sm text-purple-700">
            Using advanced AI to create personalized activities tailored specifically for {childName}'s learning needs and interests.
          </p>
        </div>
      </div>
    </div>
  );
}
